import { render, staticRenderFns } from "./info-detail.vue?vue&type=template&id=b097a298&scoped=true&"
import script from "./info-detail.vue?vue&type=script&lang=ts&"
export * from "./info-detail.vue?vue&type=script&lang=ts&"
import style0 from "./info-detail.vue?vue&type=style&index=0&id=b097a298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b097a298",
  null
  
)

export default component.exports